import type { State } from '../types';
import type { LineItemsActualEstimate } from '../../ui/order-summary/src/components/types';

export function getLineItemsActualEstimate(state: State) {
  const totalExcludingDiscountAndTax = state.billEstimate?.partnerPricing?.totalExcludingDiscountAndTax || 0;
  const totalAmountToPay = state.billEstimate?.partnerPricing?.grandTotal || 0;
  const totalTax = state.billEstimate?.partnerPricing?.totalTax || 0;
  const totalDiscountApplied = state.billEstimate?.partnerPricing?.totalDiscount || 0;

  const lineItemsActualEstimate: LineItemsActualEstimate = {
    totalExcludingDiscountAndTax: totalExcludingDiscountAndTax,
    totalAmountToPay: totalAmountToPay,
    totalTax: totalTax,
    totalDiscountApplied: totalDiscountApplied,
  };

  return lineItemsActualEstimate;
}
